/**
 * ware-quick-add
 * Custom element for quick-adding products to cart.
 * Always adds to cart directly — no navigation to PDP.
 */
class WareQuickAdd extends HTMLElement {
  connectedCallback() {
    this._btn = this.querySelector('[data-quick-add-btn]');
    this._variantId = this.dataset.variantId;
    this._productHandle = this.dataset.productHandle;

    if (this._btn) {
      this._btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._addToCart();
      });
    }
  }

  async _addToCart() {
    if (!this._variantId) return;
    const btn = this._btn;
    const originalText = btn.textContent;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this._variantId, quantity: 1 })
      });

      if (res.ok) {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);
      } else {
        btn.textContent = 'Out of stock';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      }
    } catch (e) {
      btn.textContent = originalText;
      btn.disabled = false;
      console.error('WARE quick add failed', e);
    }
  }
}

customElements.define('ware-quick-add', WareQuickAdd);
